import { apiService } from './api.service';
import type { LoginCredentials, RegisterCredentials, AuthResponse, User } from '../types/auth.types';

class AuthService {
  async login(credentials: LoginCredentials): Promise<AuthResponse> {
    return apiService.post<AuthResponse>('/auth/local', credentials, {
      skipAuth: true,
    });
  }

  async register(credentials: RegisterCredentials): Promise<AuthResponse> {
    return apiService.post<AuthResponse>('/auth/local/register', credentials, {
      skipAuth: true,
    });
  }

  async getCurrentUser(): Promise<User> {
    return apiService.get<User>('/users/me');
  }

  async forgotPassword(email: string): Promise<void> {
    return apiService.post('/auth/forgot-password', { email }, {
      skipAuth: true,
    });
  }

  async resetPassword(
    code: string,
    password: string,
    passwordConfirmation: string
  ): Promise<void> {
    return apiService.post(
      '/auth/reset-password',
      { code, password, passwordConfirmation },
      { skipAuth: true }
    );
  }
}

export const authService = new AuthService();
